// extracted by mini-css-extract-plugin
module.exports = {"bubbleLeft":"Bubble_bubbleLeft__2wWZI","bubbleRight":"Bubble_bubbleRight__3yszd"};